module.exports = __webpack_public_path__ + "static/img/phone.31ca9e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/bottomfix/phone.png
// module id = XStp
// module chunks = 0